import { render } from "./WishesGrid.vue?vue&type=template&id=2124eb64&scoped=true"
import script from "./WishesGrid.vue?vue&type=script&lang=js"
export * from "./WishesGrid.vue?vue&type=script&lang=js"

import "./WishesGrid.vue?vue&type=style&index=0&id=2124eb64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2124eb64"]])

export default __exports__